import { render, staticRenderFns } from "./OrderCreateView.vue?vue&type=template&id=6ceaadf2&scoped=true&"
import script from "./OrderCreateView.vue?vue&type=script&lang=js&"
export * from "./OrderCreateView.vue?vue&type=script&lang=js&"
import style1 from "./OrderCreateView.vue?vue&type=style&index=1&id=6ceaadf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ceaadf2",
  null
  
)

export default component.exports